import _ from 'lodash';
import Immutable from 'immutable';
import { resolveViewType, VIEW_TYPES } from './viewType';

/**
 * Классифицирует виды на:
 * - commonViews: обычные виды + права-виды с явным правилом для текущего пользователя
 * - foreignRightsViews: права-виды, которые admin каталога видит без личных правил
 *
 * Логика:
 *   forRights: false                             → commonViews
 *   forRights: true + privilegeCode !== 'admin'  → commonViews (есть явное правило)
 *   forRights: true + privilegeCode === 'admin'  → foreignRightsViews
 */
export function classifyViews(views) {
  let viewsList = (views && views.valueSeq()) || new Immutable.Seq();

  const allRecordsView = viewsList.find((v) => v.get('id') === '0');
  const newView = viewsList.find((v) => v.get('id') === '$new');

  viewsList = viewsList.filter((v) => v.get('id') !== '0' && v.get('id') !== '$new');

  const { foreignRightsViews: foreignArr, commonViews: commonArr } = viewsList.reduce(
    (result, view) => {
      if (!view.get('displayName')) return result;
      const type = resolveViewType(view);
      if (type === VIEW_TYPES.SHARED && view.get('privilegeCode') === 'admin') {
        result.foreignRightsViews.push(view);
      } else {
        result.commonViews.push(view);
      }
      return result;
    },
    { foreignRightsViews: [], commonViews: [] },
  );

  const sortedCommon = _.sortBy(commonArr, (v) => v.get('displayName'));
  const sortedForeign = _.sortBy(foreignArr, (v) => v.get('displayName'));

  let commonList = allRecordsView ? [allRecordsView, ...sortedCommon] : sortedCommon;
  commonList = newView ? [...commonList, newView] : commonList;

  return {
    commonViews: Immutable.List(commonList),
    foreignRightsViews: Immutable.List(sortedForeign),
  };
}
